export const MAP_KEY_STORAGE = 'map-key'

// A deployment can pin the Google Maps key with REACT_APP_GOOGLE_MAP_KEY; otherwise it comes from the
// API's key-setting endpoint (fetched in App.tsx) and is kept in localStorage.
export const configuredMapKey = (): string => window.__RUNTIME_CONFIG__?.REACT_APP_GOOGLE_MAP_KEY || ''

export const getMapKey = (): string => configuredMapKey() || localStorage.getItem(MAP_KEY_STORAGE) || ''
